/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

// document.addEventListener('DOMContentLoaded', function() {
//   document.getElementById('carfaxButton').addEventListener('click', function(event) {
//     event.stopPropagation();
//     var newHref = this.getAttribute('data-href');
//     window.location.href = newHref;
//   });
// });
import $ from 'jquery';

$(function() {
  $('.carfaxButton').on("click", function(event) {
      event.stopPropagation();
      let dataHref = $(this).data('href');
      window.location.assign(dataHref);
      return false;
  });
});